import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { NvDesignLibraryModule } from '../../../nvps-libraries/design/nv-design-library.module';
import { PageHeaderModule } from '../../shared/components/header/page-header/page-header.module';
import { InfiniteTableModule } from '../../shared/components/list/infinite-table/infinite-table.module';
import { NetworkSettingsContentComponent } from './network-settings-content/network-settings-content.component';
import { NetworkSettingsLeftNavComponent } from './network-settings-left-nav/network-settings-left-nav.component';
import { NetworkSettingsMadLibComponent } from './network-settings-mad-lib/network-settings-mad-lib.component';
import { NetworkSettingsMoreButtonComponent } from './network-settings-more-button/network-settings-more-button.component';
import { NetworkSettingsRightNavComponent } from './network-settings-right-nav/network-settings-right-nav.component';
import { NetworkSettingsComponent } from './network-settings.component';

@NgModule({
  declarations: [
    NetworkSettingsComponent,
    NetworkSettingsLeftNavComponent,
    NetworkSettingsRightNavComponent,
    NetworkSettingsContentComponent,
    NetworkSettingsMadLibComponent,
    NetworkSettingsMoreButtonComponent,
  ],
  imports: [CommonModule, InfiniteTableModule, PageHeaderModule, NvDesignLibraryModule, MatMenuModule],
  entryComponents: [NetworkSettingsMoreButtonComponent],
})
export class NetworkSettingsModule {}
